let sessionStorageAvailable = false;

try {
  sessionStorage.getItem("CmonSessionStoragePleaseWork");
  sessionStorageAvailable = true;
} catch (error) {
  // we're inside an iFrame with the setting to block
  // 3rd party cookies... sigh
  sessionStorageAvailable = false;
}

// if sessionStorage isn't accessible, we need an in-memory replacement
const MemoryStore = () => {
  let store: { [key: string]: string } = {};

  const clear = () => {
    store = {};
  };

  const getItem = (key: string): string | null => {
    return store[key] || null;
  };

  const removeItem = (key: string): void => {
    delete store[key];
  };

  const setItem = (key: string, data: string): void => {
    store[key] = data;
  };

  return { clear, getItem, removeItem, setItem };
};

export const getSessionStorage = () => (sessionStorageAvailable ? sessionStorage : MemoryStore());

export const isSessionStorageAvailable = sessionStorageAvailable;
